import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["triggersList", "triggerTemplate", "emptyState"]

  connect() {
    this.toggleEmptyState()
    this.refreshAllSummaries()
  }

  afterAdd() {
    this.toggleEmptyState()
    this.refreshAllSummaries()
  }

  afterRemove() {
    this.toggleEmptyState()
    this.refreshAllSummaries()
  }

  updateSummary(event) {
    const triggerItem = event.target.closest('[data-campaign-configurator-target="triggerItem"]')
    if (!triggerItem) return

    this.updateTypeSummary(triggerItem)
    this.refreshConditionStates(triggerItem)
  }

  toggleEmptyState() {
    if (!this.hasEmptyStateTarget) return

    const visibleItems = Array.from(
      this.triggersListTarget.querySelectorAll('[data-campaign-configurator-target="triggerItem"]'),
    ).filter((item) => {
      const hiddenByClass = item.classList.contains("hidden")
      const hiddenByStyle = getComputedStyle(item).display === "none"
      return !(hiddenByClass || hiddenByStyle)
    })

    if (visibleItems.length === 0) {
      this.emptyStateTarget.classList.remove("hidden")
    } else {
      this.emptyStateTarget.classList.add("hidden")
    }
  }

  updateTypeSummary(triggerItem) {
    const typeSelect = triggerItem.querySelector('select[name*="[type]"]')
    const typeSummary = triggerItem.querySelector("[data-summary-type]")

    if (typeSummary && typeSelect) {
      const value = typeSelect.value
      if (value) {
        const label = value.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())
        typeSummary.textContent = label
      } else {
        typeSummary.textContent = "Unsaved trigger"
      }
    }
  }

  refreshAllSummaries() {
    if (!this.hasTriggersListTarget) return

    this.triggersListTarget
      .querySelectorAll('[data-campaign-configurator-target="triggerItem"]')
      .forEach((item) => this.refreshConditionStates(item))
  }

  refreshConditionStates(triggerItem) {
    if (!triggerItem) return

    const conditionRows = triggerItem.querySelectorAll("[data-condition-row]")
    conditionRows.forEach((row) => {
      const field = this.fieldInput(row)?.value?.trim()
      const operator = row.querySelector('select[name*="[operator]"]')?.value?.trim()
      const value = row.querySelector('input[name*="[value]"]')?.value?.trim()
      const warning = row.querySelector("[data-condition-warning]")

      const hasAnyValue = [field, operator, value].some(Boolean)
      const complete = field && operator && value

      row.classList.toggle("border-red-200", !complete && hasAnyValue)
      row.classList.toggle("bg-red-50", !complete && hasAnyValue)
      row.classList.toggle("bg-gray-50", !hasAnyValue || complete)
      if (warning) {
        warning.classList.toggle("hidden", complete || !hasAnyValue)
      }

    })
  }

  fieldInput(row) {
    return row.querySelector('select[name*="[field]"]') || row.querySelector('input[name*="[field]"]')
  }

  labelForSelect(select) {
    if (!select) return null
    const selectedOption = select.selectedOptions?.[0]
    return selectedOption ? selectedOption.textContent.trim() : null
  }

}
